import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../api-services/AdminHRService/Login/auth.service';
import { PermissionService } from '../../api-services/Permission/permission.service';
import { StorageService } from '../../guards/StorageService';
import { ModuleService } from '../../api-services/AdminHRService/Module/module.service';
import { firstValueFrom } from 'rxjs';
import { ChatService } from '../../api-services/AIChatBoat/chat.service';

@Component({
  selector: 'app-lending',
  standalone: false,
  templateUrl: './lending.component.html',
  styleUrls: ['./lending.component.css']
})

export class LendingComponent implements OnInit {
  loginUserDetails: any;
  userImage: string = "assets/media/avatars/300-3.jpg";
  EmployeeName: any;
  DesignationName: any;
  allowedModules: any[] = []
  moduleDetails: any[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private chatService: ChatService,
    private readonly permissionService: PermissionService,
    public storageService: StorageService,
    private moduleService: ModuleService,
  ) { }

  async ngOnInit() {
    if (!this.authService.getUser()) {
      this.authService.getAccessToken();
    }

    const user = this.authService.getUser();
    this.EmployeeName = user?.employeeName;
    this.DesignationName = user?.designation;

    await this.loadModules();

    const allowedModules = this.authService.getAllowedModules() || [];

    const mapped = this.moduleDetails.map(m => ({
      id: m.moduleId,
      name: m.module,
      displayName: m.moduleDisplayName || m.module,
      icon: m.moduleIcon,
      enabled: allowedModules.includes(m.module)
    }));

    mapped.sort((a, b) => a.displayName.localeCompare(b.displayName));

    const positions = this.generateCirclePositions(mapped.length, 40);

    this.allowedModules = mapped.map((mod, i) => ({
      ...mod,
      pos: positions[i]
    }));
  }

  async loadModules(): Promise<void> {
    const modules = await firstValueFrom(this.moduleService.getActiveModule());
    this.moduleDetails = modules.data;
  }

  generateCirclePositions(count: number, radius: number = 45) {
    const positions = [];
    const step = (2 * Math.PI) / count;

    for (let i = 0; i < count; i++) {
      const angle = step * i - Math.PI / 2;

      const top = 50 + radius * Math.sin(angle);
      const left = 50 + radius * Math.cos(angle);

      positions.push({
        top: `${top}%`,
        left: `${left}%`
      });
    }
    return positions;
  }

  goTo(moduleName: string) {
    if (!this.authService.getAllowedModules().includes(moduleName)) return;
    this.router.navigate([`/${moduleName}`]);
  }

  getAnimationDelay(index: number): string {
    return `${index * 0.15}s`;
  }

  btnSignOut() {
    this.authService.logout();
    this.permissionService.clear();
    this.storageService.clearAll();
    this.chatService.clearSession();  // ← clear chat first
    this.authService.logout();        // then logout
    this.router.navigateByUrl('/SignIn');
  }
}
